<!-- Layout Desktop -->
<div *ngIf="!isMobile" class="desktop-layout">
  <div class="row">
    <div class="col-6" style="text-align: center;">
      <h2 class="title">Choose your 5 numbers</h2>
      <div class="box-content compact">
        <ul *ngFor="let row of matrix" class="tf-social style-2">
          <li *ngFor="let num of row" class="selectable-number">
            <a href="javascript:void(0)" (click)="toggleNumberSelection(num)">
              <strong class="icon">{{ num }}</strong>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-6" style="display: flex; justify-content: center;">
      <div class="box-content compact">
        <ul class="tf-social style-2 flex-wrap">
          <li *ngFor="let number of selectedNumbers">
            <a href="javascript:void(0)" (click)="deselectNumber(number)" class="selected-number-container">
              <i class="icon" [class.selected-number]="isSelected(number)">{{ number }}</i>
            </a>
          </li>
        </ul>
        <div class="button-container proceed" *ngIf="selectedNumbers.length === 5">
          <div>
            <h3 class="subtitle" style="text-align: center;">Are you ready to move forward?</h3>
          </div>
          <div style="display: flex; justify-content: center; gap: 10px;">
            <button class="tf-btn style-1" (click)="resetSelection()">Change my numbers</button>
            <button class="tf-btn style-1" (click)="proceed()">I'm ready to vote a ticket</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Layout Mobile -->
<div *ngIf="isMobile" class="mobile-layout">
  <div class="mobile-select">
    <h2 class="title" style="margin-bottom: 15px;">Choose your 5 numbers</h2>
    <div class="box-content compact">
      <ul *ngFor="let row of matrix" class="tf-social style-2">
        <li *ngFor="let num of row" class="selectable-number">
          <a href="javascript:void(0)" (click)="toggleNumberSelection(num)">
            <strong class="icon">{{ num }}</strong>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="mobile-selected">
    <ul class="tf-social style-2" style="margin-bottom: 20px;">
      <li *ngFor="let number of selectedNumbers">
        <a href="javascript:void(0)" (click)="deselectNumber(number)" class="selected-number-container">
          <i class="icon" [class.selected-number]="isSelected(number)">{{ number }}</i>
        </a>
      </li>
    </ul>
    <div class="button-container proceed" *ngIf="selectedNumbers.length === 5">
      <div>
        <h4 class="subtitle" style="text-align: center; margin-bottom: 20px;">Are you ready to move forward?</h4>
      </div>
      <div style="display: flex; justify-content: center; gap: 10px; margin-bottom: 20px;">
        <button class="tf-btn style-1" (click)="proceed()">I'm ready to vote a ticket</button>
        <button class="tf-btn style-1" (click)="resetSelection()">Change my numbers</button>
      </div>
    </div>
  </div>
</div>